import React, { useEffect, useState, useContext } from 'react';
import { Row, Card, Col } from 'react-bootstrap';
import { TotalUnitState } from '../types/type';
import numberFormat from "../helpers/numberFormat"
import { UserContext } from "../context/UserContext";

export default ({
  sectionType
}: {
  sectionType: string
}) => {
  const userState = useContext(UserContext);

  const [settings, setSettings] = useState<any>(null)
  const [packages, setPackages] = useState<TotalUnitState | null>(null)
  const [undifferenciated, setUndifferenciated] = useState<TotalUnitState | null>(null)
  const [packages2, setPackages2] = useState<TotalUnitState | null>(null)
  const [undifferenciated2, setUndifferenciated2] = useState<TotalUnitState | null>(null)



  const [m3Packages, setM3Packages] = useState<TotalUnitState | null>(null)
  const [m3Undifferenciated, setM3Undifferenciated] = useState<TotalUnitState | null>(null)
  const [kgPackages, setKgPackages] = useState<TotalUnitState | null>(null)
  const [kgUndifferenciated, setKgUndifferenciated] = useState<TotalUnitState | null>(null)

  const [m3PackagesEstimated, setM3PackagesEstimated] = useState<TotalUnitState | null>(null)
  const [m3UndifferenciatedEstimated, setM3UndifferenciatedEstimated] = useState<TotalUnitState | null>(null)
  const [kgPackagesEstimated, setKgPackagesEstimated] = useState<TotalUnitState | null>(null)
  const [kgUndifferenciatedEstimated, setKgUndifferenciatedEstimated] = useState<TotalUnitState | null>(null)


  useEffect(() => {
    async function init() {
      let response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/unit_settings`);
      const settingsRequest = (await response.json());
      setSettings(settingsRequest)
      
      if (sectionType === "collected") {
        if(settingsRequest.settings.ShowOnlyInitialData){
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/init_m3packages${userState.role !== 'admin'? ("?apikey=" + userState.apikey) : ""}`);
            setPackages((await response.json()));
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/init_m3undifferentiated${userState.role !== 'admin' ? ("?apikey=" + userState.apikey) : ""}`);
            setUndifferenciated((await response.json()));
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/init_kgpackages${userState.role !== 'admin' ? ("?apikey=" + userState.apikey) : ""}`);
            setPackages2((await response.json()));
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/init_kgundifferentiated${userState.role !== 'admin' ? ("?apikey=" + userState.apikey) : ""}`);
            setUndifferenciated2((await response.json()));
          
          /*if (settingsRequest.settings.UnitID === 3 || settingsRequest.settings.Abbreviation === "M3" ) {
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/init_m3packages${userState.role !== 'admin'? ("?apikey=" + userState.apikey) : ""}`);
            setPackages((await response.json()));
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/init_m3undifferentiated${userState.role !== 'admin' ? ("?apikey=" + userState.apikey) : ""}`);
            setUndifferenciated((await response.json()));
          }
          else if (settingsRequest.settings.UnitID === 1 || settingsRequest.settings.Abbreviation === "KG" ) {
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/init_kgpackages${userState.role !== 'admin' ? ("?apikey=" + userState.apikey) : ""}`);
            setPackages((await response.json()));
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/init_kgundifferentiated${userState.role !== 'admin' ? ("?apikey=" + userState.apikey) : ""}`);
            setUndifferenciated((await response.json()));
          }*/
        } else {
          response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/estimated_m3packages${userState.role !== 'admin' ? ("?apikey=" + userState.apikey) : ""}`);
            setPackages((await response.json()));
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/estimated_m3undifferentiated${userState.role !== 'admin' ? ("?apikey=" + userState.apikey) : ""}`);
            setUndifferenciated((await response.json()));
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/estimated_kgpackages${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
            setPackages2((await response.json()));
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/estimated_kgundifferentiated${userState.role !== 'admin' ? ("?apikey=" + userState.apikey) : ""}`);
            setUndifferenciated2((await response.json()));

          /*if (settingsRequest.settings.UnitID === 3 || settingsRequest.settings.Abbreviation === "M3" ) {
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/estimated_m3packages${userState.role !== 'admin' ? ("?apikey=" + userState.apikey) : ""}`);
            setPackages((await response.json()));
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/estimated_m3undifferentiated${userState.role !== 'admin' ? ("?apikey=" + userState.apikey) : ""}`);
            setUndifferenciated((await response.json()));
          }
          else if (settingsRequest.settings.UnitID === 1 || settingsRequest.settings.Abbreviation === "KG" ) {
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/estimated_kgpackages${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
            setPackages((await response.json()));
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/estimated_kgundifferentiated${userState.role !== 'admin' ? ("?apikey=" + userState.apikey) : ""}`);
            setUndifferenciated((await response.json()));
          }*/
        }
      } else if (sectionType === "delivered") {
        if(settingsRequest.settings.ShowOnlyInitialData){
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/init_m3packages${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
            setPackages((await response.json()));
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/init_m3undifferentiated${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
            setUndifferenciated((await response.json()));
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/init_kgpackages${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
            setPackages2((await response.json()));
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/init_kgundifferentiated${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
            setUndifferenciated2((await response.json()));
          /*
          if (settingsRequest.settings.UnitID === 3 || settingsRequest.settings.Abbreviation === "M3" ) {
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/init_m3packages${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
            setPackages((await response.json()));
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/init_m3undifferentiated${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
            setUndifferenciated((await response.json()));
          }
          else if (settingsRequest.settings.UnitID === 1 || settingsRequest.settings.Abbreviation === "KG" ) {
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/init_kgpackages${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
            setPackages((await response.json()));
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/collected/init_kgundifferentiated${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
            setUndifferenciated((await response.json()));
          }*/
        } else {
          response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/delivered/estimated_m3packages${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
          setPackages((await response.json()));
          response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/delivered/estimated_m3undifferentiated${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
          setUndifferenciated((await response.json()));
          response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/delivered/estimated_kgpackages${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
          setPackages2((await response.json()));
          response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/delivered/estimated_kgundifferentiated${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
          setUndifferenciated2((await response.json()));
          /*
          if (settingsRequest.settings.UnitID === 3 || settingsRequest.settings.Abbreviation === "M3" ) {
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/delivered/estimated_m3packages${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
            setPackages((await response.json()));
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/delivered/estimated_m3undifferentiated${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
            setUndifferenciated((await response.json()));
          }
          else if (settingsRequest.settings.UnitID === 1 || settingsRequest.settings.Abbreviation === "KG" ) {
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/delivered/estimated_kgpackages${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
            setPackages((await response.json()));
            response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/delivered/estimated_kgundifferentiated${userState.role !== 'admin' ? ("?apikey=" + userState.apikey): ""}`);
            setUndifferenciated((await response.json()));
          }*/
        }
      }
    }
    init()
  }, [sectionType])

  return (
    <React.Fragment>
      <Row style={{ margin: "10px" }}>
        <Col>
          <Card>
            <Card.Body>
              <Card.Title style={{ textAlign: "center" }}>{packages && numberFormat(packages.unitCount, false) + " m³" /*+ settings.settings.AbbreviationText*/}</Card.Title>
              {
                sectionType === "collected" && <Card.Subtitle style={{ textAlign: "center" }} className="mb-2 text-muted">Embalagens Recolhidas</Card.Subtitle>
              }
              {
                sectionType === "delivered" && <Card.Subtitle style={{ textAlign: "center" }} className="mb-2 text-muted">Embalagens Entregues</Card.Subtitle>
              }
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card>
            <Card.Body>
              <Card.Title style={{ textAlign: "center" }}>{undifferenciated && numberFormat(undifferenciated.unitCount, false) + " m³" /*+ settings.settings.AbbreviationText*/}</Card.Title>
              {
                sectionType === "collected" && <Card.Subtitle style={{ textAlign: "center" }} className="mb-2 text-muted">Indiferenciados Recolhidos</Card.Subtitle>
              }
              {
                sectionType === "delivered" && <Card.Subtitle style={{ textAlign: "center" }} className="mb-2 text-muted">Indiferenciados Entregues</Card.Subtitle>
              }
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row style={{ margin: "10px" }}>
        <Col>
          <Card>
            <Card.Body>
              <Card.Title style={{ textAlign: "center" }}>{packages2 && numberFormat(packages2.unitCount, false) + " Kg"/* + settings.settings.AbbreviationText*/}</Card.Title>
              {
                sectionType === "collected" && <Card.Subtitle style={{ textAlign: "center" }} className="mb-2 text-muted">Embalagens Recolhidas</Card.Subtitle>
              }
              {
                sectionType === "delivered" && <Card.Subtitle style={{ textAlign: "center" }} className="mb-2 text-muted">Embalagens Entregues</Card.Subtitle>
              }
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card>
            <Card.Body>
              <Card.Title style={{ textAlign: "center" }}>{undifferenciated2 && numberFormat(undifferenciated2.unitCount, false) + " Kg"/* + settings.settings.AbbreviationText*/}</Card.Title>
              {
                sectionType === "collected" && <Card.Subtitle style={{ textAlign: "center" }} className="mb-2 text-muted">Indiferenciados Recolhidos</Card.Subtitle>
              }
              {
                sectionType === "delivered" && <Card.Subtitle style={{ textAlign: "center" }} className="mb-2 text-muted">Indiferenciados Entregues</Card.Subtitle>
              }
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}
